import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Shop} from 'interfaces';
import {Badge, BadgeProps, Link, Flex} from 'components/UIKit';
import styles from '../../ListingCard.scss';
import * as locales from '../../locales';

interface CardHeaderProps {
  shop: Shop;
  shopPath: string;
}

interface BadgeDescriptor {
  text: BadgeProps['text'];
  type: BadgeProps['type'];
}

const BUSINESSES_OFFERING_POST_SALE_SUPPORT = 'businesses-offering-post-sale-support';

export function CardHeaderComponent({shop, shopPath, i18n}: CardHeaderProps & WithI18nProps) {
  const badges: BadgeDescriptor[] = [];
  const offersPostSaleSupport = shop.categories.filter(
    (category) => category.handle === BUSINESSES_OFFERING_POST_SALE_SUPPORT,
  );

  if (shop.sold) {
    badges.push({
      text: i18n.translate('sold'),
      type: 'lightGrey',
    });
  }

  if (!shop.sold && shop.featured) {
    badges.push({
      text: i18n.translate('featured'),
      type: 'primary',
    });
  }

  if (offersPostSaleSupport.length > 0) {
    badges.push({
      text: i18n.translate('offersPostSaleSupport'),
      type: 'blue',
    });
  }

  const showBadges = badges.length > 0;
  return (
    <div className={styles.header}>
      {showBadges && (
        <Flex className={styles.badges} wrap="wrap" wrapperComponent="ul">
          {badges.map((badge) => (
            <Badge key={badge.text} {...badge} className={styles.badge} wrapperComponent="li" />
          ))}
        </Flex>
      )}
      <Link url={shopPath} text={shop.title} type="h3" className={styles.title} />
    </div>
  );
}

export const CardHeader = withI18n({
  id: 'CardHeader',
  fallback: locales.en,
})(CardHeaderComponent);
